"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolatilityModel = exports.SwapCalculationMethod = void 0;
__exportStar(require("./surfaces"), exports);
var SwapCalculationMethod;
(function (SwapCalculationMethod) {
    SwapCalculationMethod["FxSwap"] = "FxSwap";
    SwapCalculationMethod["FxSwapImpliedFromDeposit"] = "FxSwapImpliedFromDeposit";
    SwapCalculationMethod["DepositCcy1ImpliedFromFxSwap"] = "DepositCcy1ImpliedFromFxSwap";
    SwapCalculationMethod["DepositCcy2ImpliedFromFxSwap"] = "DepositCcy2ImpliedFromFxSwap";
})(SwapCalculationMethod || (exports.SwapCalculationMethod = SwapCalculationMethod = {}));
var VolatilityModel;
(function (VolatilityModel) {
    VolatilityModel["SVI"] = "SVI";
    VolatilityModel["SABR"] = "SABR";
    VolatilityModel["CubicSpline"] = "CubicSpline";
    VolatilityModel["TwinLognormal"] = "TwinLognormal";
})(VolatilityModel || (exports.VolatilityModel = VolatilityModel = {}));
